.avatar,
.generated {
  width: var(--avatar-size);
  height: var(--avatar-size);
  border-radius: 50%;
  flex-shrink: 0;
  border: 2px solid var(--avatar-accent);
}

.avatar {
  object-fit: cover;
}

/* Stand-in image for profiles with no photo, built from the display name. */
.generated {
  display: grid;
  place-items: center;
  font-family: var(--font-display);
  font-size: calc(var(--avatar-size) * 0.41);
  font-weight: 700;
  line-height: 1;
  color: #FFFFFF;
  background: var(--avatar-accent);
  user-select: none;
}
